import { Search } from "lucide-react";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { commandPaletteOpenAtom } from "@/store/ui";

/**
 * CommandSearchInput — the header trigger for the command palette (Sprint 142,
 * TASK-4221). Rendered in the right header cluster of both AdminShell and
 * DealerShell, before the language switch.
 *
 * It looks like a search input but is a button: clicking, focusing, or pressing
 * Enter/Space opens the palette (which owns the real, focus-trapped input). A
 * trailing `⌘K` hint advertises the global shortcut; `aria-keyshortcuts`
 * exposes it to assistive tech.
 */
export function CommandSearchInput() {
  const { t } = useTranslation();
  const setOpen = useSetAtom(commandPaletteOpenAtom);

  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      onFocus={() => setOpen(true)}
      aria-keyshortcuts="Meta+K Control+K"
      aria-label={t("commandPalette.triggerLabel")}
      className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-500 transition-colors hover:border-gray-400 hover:text-gray-700 focus:border-brand-primary focus:outline-none focus:ring-1 focus:ring-brand-primary sm:min-w-[13rem]"
    >
      <Search size={15} aria-hidden="true" className="shrink-0" />
      <span className="hidden flex-1 text-left sm:inline">
        {t("commandPalette.triggerPlaceholder")}
      </span>
      <kbd className="hidden shrink-0 rounded border border-gray-300 bg-white px-1.5 py-0.5 font-mono text-[10px] font-semibold text-gray-500 sm:inline">
        ⌘K
      </kbd>
    </button>
  );
}
